import { standerdDateForDataCreation } from "../utils/dataFilter";
import http, { host } from "./httpService";

export const GetETAAggregate_Aryabhatta = async (date) => {
  const response =  await http.get(host + "GetETAAggregate_Aryabhatta", { params: { Fromdate: date.fromdate, ToDate:date.todate } });
  return response.data.map((item)=>{
    return {
      ...item,
      Date : standerdDateForDataCreation(item.Date)
    }
  })
};

export const InsertBulkDataIntoETAAggregate_Aryabhatta = async (data) => {
  return await http.post(host + "InsertBulkDataIntoETAAggregate_Aryabhatta  ", { _jsonBulkDataIntoETAAggregate: data,});
};

export const DeleteAggregateETAData = async (data) => {
  return await http.delete(host + "DeleteAggregateETAData", {data})
}

